import React,{useEffect,useState} from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import Footer from '../layout/Footer';
import SalaryStructure from './SalaryStructure';

import UserImg from '../../images/user-img/user_1.jpg';

import Icon from '@mdi/react';
import { mdiCalendarCheck, mdiCellphone, mdiEmailOutline, mdiOfficeBuildingOutline, mdiCalendarOutline, mdiMapMarkerOutline, mdiAccountTie, mdiSitemapOutline } from '@mdi/js';
import PaySlips from './PaySlips';
import AnunualEarnings from './AnunualEarnings';
import SalaryPayslip from './SalaryPayslip';
import {getFromAPI,formatDate} from '../../Utils/utils';

export default function PayRoll() {
    const firstName = localStorage.getItem('firstName');
    const isStaffId = Number(localStorage.getItem('loggedInStaffId'));
    const [staffData,setStaffData] = useState([]);
    const fetchStaffData = async() => {
       try{
        const response = await getFromAPI(`FtsStaff/?staffid=${isStaffId}`);
        if(response){
        setStaffData(response[0]);
        }
        else
        {
            setStaffData([])
        }
       }
       catch(error){
         return null;
       }
    };

    useEffect(() => {
        fetchStaffData();
    },[]);

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col md={12}>
                                <Card>
                                    <Card.Body>
                                        <div className="d-md-flex align-items-center">
                                            <div className="flex-shrink-0 text-center">
                                                <Image src={UserImg} thumbnail roundedCircle alt="..." className='avatar-xxxl' />
                                                <h5 className='mb-1 mt-3'>{staffData.firstname}</h5>
                                                <p className='mb-0 text-muted'>{staffData.designation}</p>
                                            </div>
                                            <div className="flex-grow-1 mt-4 mt-md-0 ms-md-5 ps-md-5">
                                                <Row>
                                                    <Col sm={6} lg={4} xl={3}>
                                                        <div className="d-flex align-items-center my-3">
                                                            <div className="flex-shrink-0">
                                                                <div className='avatar avatar-md bg-soft-primary border border-soft-primary text-primary'>
                                                                    <Icon path={mdiCalendarCheck} className='avatar-icon' />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className='mb-2 fs-15'>Date of Birth</h5>
                                                                <p className='text-muted mb-0 fs-14'>{formatDate(staffData.birth_date)}</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} lg={4} xl={3}>
                                                        <div className="d-flex align-items-center my-3">
                                                            <div className="flex-shrink-0">
                                                                <div className='avatar avatar-md bg-soft-success border border-soft-success text-success'>
                                                                    <Icon path={mdiCellphone} className='avatar-icon' />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className='mb-2 fs-15'>Mobile Number</h5>
                                                                <p className='text-muted mb-0 fs-14'>{staffData.phonenumber}</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} lg={4} xl={3}>
                                                        <div className="d-flex align-items-center my-3">
                                                            <div className="flex-shrink-0">
                                                                <div className='avatar avatar-md bg-soft-info border border-soft-info text-info'>
                                                                    <Icon path={mdiEmailOutline} className='avatar-icon' />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className='mb-2 fs-15'>Contact Mail</h5>
                                                                <p className='text-muted mb-0 fs-14'>{staffData.email}</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} lg={4} xl={3}>
                                                        <div className="d-flex align-items-center my-3">
                                                            <div className="flex-shrink-0">
                                                                <div className='avatar avatar-md bg-soft-warning border border-soft-warning text-warning'>
                                                                    <Icon path={mdiAccountTie} className='avatar-icon' />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className='mb-2 fs-15'>Employee ID</h5>
                                                                <p className='text-muted mb-0 fs-14'>{staffData.staffid}</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} lg={4} xl={3}>
                                                        <div className="d-flex align-items-center my-3">
                                                            <div className="flex-shrink-0">
                                                                <div className='avatar avatar-md bg-soft-dark border border-soft-dark text-dark'>
                                                                    <Icon path={mdiOfficeBuildingOutline} className='avatar-icon' />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className='mb-2 fs-15'>Company</h5>
                                                                <p className='text-muted mb-0 fs-14'>Foogle Tech Software</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} lg={4} xl={3}>
                                                        <div className="d-flex align-items-center my-3">
                                                            <div className="flex-shrink-0">
                                                                <div className='avatar avatar-md bg-soft-warning border border-soft-warning text-warning'>
                                                                    <Icon path={mdiCalendarOutline} className='avatar-icon' />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className='mb-2 fs-15'>Date Of Join</h5>
                                                                <p className='text-muted mb-0 fs-14'>{formatDate(staffData.joining_date)}</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} lg={4} xl={3}>
                                                        <div className="d-flex align-items-center my-3">
                                                            <div className="flex-shrink-0">
                                                                <div className='avatar avatar-md bg-soft-danger border border-soft-danger text-danger'>
                                                                    <Icon path={mdiMapMarkerOutline} className='avatar-icon' />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className='mb-2 fs-15'>Location</h5>
                                                                <p className='text-muted mb-0 fs-14'>Surat</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    {/* <Col sm={6} lg={4} xl={3}>
                                                        <div className="d-flex align-items-center my-3">
                                                            <div className="flex-shrink-0">
                                                                <div className='avatar avatar-md bg-soft-primary border border-soft-primary text-primary'>
                                                                    <Icon path={mdiSitemapOutline} className='avatar-icon' />
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 ms-3">
                                                                <h5 className='mb-2 fs-15'>Department</h5>
                                                                <p className='text-muted mb-0 fs-14'>UI Design</p>
                                                            </div> 
                                                        </div>
                                                    </Col> */}
                                                </Row>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={12}>
                                <h5 className='my-3'>Salary Details</h5>
                                <Card>
                                    <Card.Body>
                                        <div className='custom-top-nav-tab'>
                                            <ul className="nav nav-pills nav-fill btn-list mb-3" id="pills-tab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link active" id="pills-salary-structure-tab" data-bs-toggle="pill" data-bs-target="#pills-salary-structure" type="button" role="tab" aria-controls="pills-salary-structure" aria-selected="true">Salary Structure</button>
                                                </li>
                                                {/* <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-paySlips-tab" data-bs-toggle="pill" data-bs-target="#pills-paySlips" type="button" role="tab" aria-controls="pills-paySlips" aria-selected="false">PaySlips</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-anunual-earnings-tab" data-bs-toggle="pill" data-bs-target="#pills-anunual-earnings" type="button" role="tab" aria-controls="pills-anunual-earnings" aria-selected="false">Anunual Earnings</button>
                                                </li> */}
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-salary-payslip-info-tab" data-bs-toggle="pill" data-bs-target="#pills-salary-payslip-info" type="button" role="tab" aria-controls="pills-salary-payslip-info" aria-selected="false">Salary Payslip Info</button>
                                                </li>
                                            </ul>
                                            <div className="tab-content mt-4" id="pills-tabContent">
                                                <div className="tab-pane fade show active" id="pills-salary-structure" role="tabpanel" aria-labelledby="pills-salary-structure-tab" tabIndex="0">
                                                    <SalaryStructure />
                                                </div>
                                                {/* <div className="tab-pane fade" id="pills-paySlips" role="tabpanel" aria-labelledby="pills-paySlips-tab" tabIndex="0">
                                                    <PaySlips/>
                                                </div>
                                                <div className="tab-pane fade" id="pills-anunual-earnings" role="tabpanel" aria-labelledby="pills-anunual-earnings-tab" tabIndex="0">
                                                    <AnunualEarnings/>
                                                </div> */}
                                                <div className="tab-pane fade" id="pills-salary-payslip-info" role="tabpanel" aria-labelledby="pills-salary-payslip-info-tab" tabIndex="0">
                                                    <SalaryPayslip/>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* <Col md={4}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Your Payslip</span>
                                            <Form.Select size='sm' className='w-auto'>
                                                <option value="01">January 2025</option>
                                                <option value="02">February 2025</option>
                                                <option value="03">March 2025</option>
                                                <option value="04">April 2025</option>
                                            </Form.Select>
                                        </Card.Title>

                                        <div id="chart">
                                            <ReactApexChart options={state.options} series={state.series} type="donut" height={300} />
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col> */}
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
